import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditTeeTimeSettingsPage } from './edit-teetime-settings';

const routes: Routes = [
  {
    path: '',
    component: EditTeeTimeSettingsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditTeeTimeSettingsPageRoutingModule {}
